<template>
<div>
    <v-toolbar dark flat dense class="grey darken-3 ma-4">
        <v-toolbar-title>Користувачi</v-toolbar-title>
        <v-btn icon @click="getDataFromApi()" title="Оновити">
            <v-icon color="grey">mdi-cached</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-account-search" label="Пошук" single-line hide-details></v-text-field>
    </v-toolbar>

    <v-data-table dark :headers="headers" :items="list" :footer-props="footerProps" :search="search" class="elevation-1 grey darken-3 ma-4" @click:row="openCard($event.member_id)">
        <template v-slot:item.contractors="{ item }">
            <span v-html="item.contractors"></span>
        </template>
        <template v-slot:item.shops="{ item }">
            <span v-html="item.shops"></span>
        </template>
        <template v-slot:item.owner="{ item }">
            <span v-if="item.owner == 1">Власник</span>
        </template>
        <template v-slot:no-data>
            ...
        </template>
    </v-data-table>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

export default {
    data: () => ({
        f: {},
        itemsMembers: [],
        isLoading: false,
        isLoadingG: false,
        open: false,
        search: '',
        searchMembers: null,
        searchGroups: null,
        footerProps: {
            'items-per-page-options': [20, 40, 80],
            'items-per-page-text': 'на стор.'
        },
        headers: [{
                text: 'ID',
                align: 'left',
                sortable: true,
                value: 'member_id',
                selected: false,
                width: '5%',
            },
            {
                text: 'Телефон',
                align: 'left',
                sortable: true,
                value: 'phone',
                selected: true,
                width: '10%',
            },
            {
                text: 'ПІБ',
                align: 'left',
                sortable: true,
                value: 'name',
                selected: true,
                width: '20%',
            },
            {
                text: 'E-mail',
                align: 'left',
                sortable: true,
                value: 'email',
                selected: true,
                width: '15%',
            },
            {
                text: 'Тип',
                align: 'left',
                sortable: true,
                value: 'owner',
                selected: true,
                width: '10%',
            },
            {
                text: 'Контрагенти',
                align: 'left',
                sortable: true,
                value: 'contractors',
                selected: true,
                width: '20%',
            },
            {
                text: 'ТТ',
                align: 'left',
                sortable: true,
                value: 'shops',
                selected: true,
                width: '20%',
            },
        ]

    }),
    watch: {
        searchMembers(val) {
            val && val !== this.f.member && this.queryMembersSelections(val)
        },
    },
    computed: {
        list() {
            return this.$store.state.adminpanel.usersList
        },
        itemsGroups() {
            return this.$store.state.adminpanel.accessGroups
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        ...mapActions(['getUsersList', 'setSnackbar']),
        queryMembersSelections(v) {
            this.isLoading = true
            this.getMembersAutocomplete(v)
                .then((data) => {
                    this.itemsMembers = data.filter(e => {
                        return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                    })
                    this.isLoading = false
                })
                .catch(err => console.log(err))
        },
        getDataFromApi() {
            this.getUsersList()
        },
        openCard(id) {
            this.$router.push('/adminpanel/users/'+id)
        },
    },
    mounted() {
        this.getDataFromApi()
    }
}
</script>
